<template>
  <div>
    <!--搜索条件-->
    <div class="searchbar">
      <el-form :inline="true" :model="filters" size="small">
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--表格栏-->
    <div class="table-wrap">
      <el-table :data="tableData.data" stripe highlight-current-row max-height="460" size="small"
                style="width:100%;">
        <el-table-column type="index" width="50" label="序号">
        </el-table-column>
        <el-table-column v-for="column in columns" header-align="center" align="center"
                         :prop="column.prop" :label="column.label" :width="column.width"
                         :min-width="column.minWidth"
                         :fixed="column.fixed" :key="column.prop" :type="column.type">
        </el-table-column>
        <el-table-column label="操作" width="300" fixed="right" header-align="center"
                         align="center">
          <template slot-scope="scope">
            <i class="icon-xs icon-delete offset-left30" title="删除"
               @click="handleDelete(scope.$index, scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>
      <!--分页栏-->
      <div class="toolbar" style="padding:10px;">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="refreshPageRequest"
                       :current-page="pageRequest.pageNum" :page-size="pageRequest.pageSize"
                       :total="tableData.totalSize" style="float:right;">
        </el-pagination>
      </div>
    </div>

    <el-dialog v-dialogDrag :title="operation==='add'?'新增':'编辑'" width="40%" :visible.sync="dialogVisible"
               :close-on-click-modal="false">
      <el-form :model="propagandaForm" :rules="rules" label-width="80px" ref="propagandaForm" size="small"
               label-position="right">
        <el-form-item label="名称" prop="title">
          <el-input v-model="propagandaForm.title" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="describeAddress">
          <el-input v-model="propagandaForm.describeAddress" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item label="图片上传" prop="file">
        <el-upload class="upload-demo" :auto-upload="false" :limit="1" :multiple="false" :on-change="handleChange"
                   action="Fake Action"  :file-list="propagandaForm.file">

          <el-button size="small" type="primary">选择文件</el-button>
          <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过10M</div>
        </el-upload>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click.native="dialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="submitForm('propagandaForm')">确认</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import {Message} from 'element-ui';
import axios from "axios";
import Cookies from "js-cookie";

export default {
  name: 'propaganda',
  data() {
    return {
      fileList:null,
      filters: {
        username: null
      },
      tableData: {
        'totalSize': 0,
        'data': []
      },
      columns: [
        {prop: 'title', label: '名称', minWidth: 120},
        {prop: 'describeAddress', label: '地址', minWidth: 120},
        {prop: 'pictureUrl', label: '图片地址', minWidth: 120},

      ],
      pageRequest: {
        pageNum: 1,
        pageSize: 10
      },
      dialogVisible: false,
      dialogResetVisible: false,
      operation: '',
      propagandaForm: {
        title: null,
        describeAddress: null,
        file:null
      },
      adminUserResetForm: {
        adminUserId: null,
        password: null,
      },
      rules: {
        title: [
          {required: true, message: '请输入名称', trigger: 'blur'}
        ],
        describeAddress: [
          {required: true, message: '请输入地址', trigger: 'blur'}
        ],
      },
      resetRules: {
        password: [
          {message: '请输入密码', trigger: 'blur', required: true}
        ],
      }
    }
  },
  methods: {

    handleChange(file, fileList) {
      this.propagandaForm.file = fileList;
    },

    // 分页查询
    findPage() {
      let requestData = {
        pageNo: this.pageRequest.pageNum,
        pageSize: this.pageRequest.pageSize,
      };
      this.$api.propaganda.selectPropaganda(requestData).then((res) => {
        this.tableData.totalSize = res.total;
        this.tableData.data = res.list;
      });
    },
    // 换页刷新
    refreshPageRequest: function (pageNum) {
      this.pageRequest.pageNum = pageNum;
      this.findPage()
    },

    // 删除
    handleDelete: function (index, row) {
      this.$confirm('确认删除选中记录吗？', '提示', {
        type: 'warning'
      }).then(() => {
        this.$api.propaganda.deletePropaganda(row.propagandaId).then(() => {
          this.refreshPageRequest(1);
          Message.success({message: '删除成功'});
        });
      }).catch(() => {
      });
    },
    //新增
    handleAdd: function () {
      this.dialogVisible = true;
      this.operation = 'add';
      this.$nextTick(() => {
        this.propagandaForm = {};
        if (this.$refs['propagandaForm'] !== undefined) {
          this.$refs['propagandaForm'].resetFields();
        }
      });
    },
    submitForm() {
      const form = new FormData()

      form.append("file", this.propagandaForm.file[0].raw);
      form.append('title', this.propagandaForm.title)
      form.append('describeAddress', this.propagandaForm.describeAddress)

      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }

      let userInfo = JSON.parse(Cookies.get('userInfo'));
      config.headers.authorization = userInfo.token;

      axios.post(process.env.VUE_APP_BASEURL + "/api/v1/propaganda", form, config)
          .then(res => {
            if (res.data.data === true){
              this.dialogVisible = false;
              this.$refs['propagandaForm'].resetFields();
              this.$message.success('新增成功');
              this.findPage();
            }
          })
    },
  },
  components: {},
  mounted() {
    this.refreshPageRequest(1)
  },
}
</script>

<style scoped>


</style>